/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {EAdasProgramsLoadingStateTypes} from "../AdasPrograms/slice";
import {IMessage} from "../../../containers/pages/radar/SensorRadar/FileProcessingMessages";


export enum ELoadingStateTypes {
  DELETE_RADAR = 'DELETE_RADAR',
  DELETE_CAMERA = 'DELETE_CAMERA',
  DELETE_ADAS_PROGRAM = 'DELETE_ADAS_PROGRAM',
  DELETE_VEHICLE_PROGRAM = 'DELETE_VEHICLE_PROGRAM',
  DELETE_COVERAGE_REQUIREMENTS_STUDY = "DELETE_COVERAGE_REQUIREMENTS_STUDY"
}

export type TLoadingState = {
  [key in ELoadingStateTypes]?: {
    isLoading: boolean
    data?: any
  }
}

interface IMiscState {
  loadingState: TLoadingState | null
}

const initialState: IMiscState = {
  loadingState: null
} as IMiscState

const miscSlice = createSlice({
  name: 'miscSlice',
  initialState,
  reducers: {
    setLoadingState: (state, action: PayloadAction<TLoadingState>) => {
      if (!state.loadingState) {
        state.loadingState = {}
      }
      state.loadingState = {...state.loadingState, ...action.payload}
    },
    setLoadingStateIsLoading: (state, action: PayloadAction<TLoadingState>) => {
      if (!state.loadingState) {
        state.loadingState = {}
      }
      state.loadingState = {...state.loadingState, ...action.payload}
    },
    setLoadingState1: {
      reducer: (state, action: PayloadAction<ELoadingStateTypes, string, {
        isLoading: boolean,
        data: any | null
      }>) => {
        if (!state.loadingState) {
        state.loadingState = {}
      }
        const type = action.payload
        const {isLoading, data} = action.meta
        let thisLoadingState = state.loadingState[type]
        if(!thisLoadingState) thisLoadingState = {isLoading, data}
        thisLoadingState.isLoading = isLoading
        if(data) thisLoadingState.data = data
        state.loadingState[type] = thisLoadingState
      },
      prepare: (payload: ELoadingStateTypes, isLoading: boolean = false, data: any = null) => ({payload, meta: {isLoading, data}})
    },
  },
})

const selectMiscState = (state: RootState) => state.miscSlice
const selectLoadingState = (state: RootState, type: ELoadingStateTypes) => state.miscSlice.loadingState?.[type]
const selectLoadingStateIsLoading = (state: RootState, type: ELoadingStateTypes) => state.miscSlice.loadingState?.[type]?.isLoading ?? false

const {actions, reducer} = miscSlice
export const {
  setLoadingState,
  setLoadingStateIsLoading,
  setLoadingState1
} = actions
export {
  selectMiscState,
  selectLoadingState,
  selectLoadingStateIsLoading,
}
export default reducer
